import React from 'react';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Dropdown from 'react-bootstrap/Dropdown';
import Accordion from 'react-bootstrap/Accordion';
import NumericInput from 'react-numeric-input';
import DestructiveButton from '../controls/DestructiveButton';
import { useForceUpdate } from '../util';
import { setMusicProperty, getTimeSignature, getMusicPropertyIndices, getMusicPropertyValue } from './TaskChordBuilder';
import { TabContextReporter } from '../TabContext';
import { FormValidityProvider, FormValidityReporter } from '../FormValidity';
export default function TaskVoiceBuilder(props) {
  const forceUpdate = useForceUpdate();
  const dataProps = props.data.props;
  const [customTime, setCustomTime] = React.useState(false);
  const [isPrefix, setIsPrefix] = React.useState(false);
  const [newProperty, setNewProperty] = React.useState('');
  function getPosition(string, subString, index) {
    return string.split(subString, index).join(subString).length;
  }
  let properties = dataProps.musicConfiguration.split('%%');
  if (properties.length > 1) {
    properties.shift();
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TabContextReporter, {
    index: "0",
    title: "1. Initial Information"
  }, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Time Signature:")), /*#__PURE__*/React.createElement(Dropdown, {
    className: "mx-2"
  }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
    id: "dropdown-basic"
  }, getTimeSignature(dataProps.musicConfiguration)), /*#__PURE__*/React.createElement(Dropdown.Menu, null, /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: e => {
      setCustomTime(false);
      dataProps.musicConfiguration = setMusicProperty(dataProps.musicConfiguration, 'M:', "C");
      forceUpdate();
      props.onChanged();
    }
  }, "Common Time"), /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: e => {
      setCustomTime(false);
      dataProps.musicConfiguration = setMusicProperty(dataProps.musicConfiguration, 'M:', "C|");
      forceUpdate();
      props.onChanged();
    }
  }, "Cut Time"), /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: e => {
      setCustomTime(false);
      dataProps.musicConfiguration = setMusicProperty(dataProps.musicConfiguration, 'M:', "3/4");
      forceUpdate();
      props.onChanged();
    }
  }, "3/4"), /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: e => {
      setCustomTime(false);
      dataProps.musicConfiguration = setMusicProperty(dataProps.musicConfiguration, 'M:', "4/4");
      forceUpdate();
      props.onChanged();
      props.triggerStateUpdate();
    }
  }, "4/4"), /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: e => {
      setCustomTime(false);
      let {
        start,
        end
      } = getMusicPropertyIndices(dataProps.musicConfiguration, 'M:');
      if (end - start < 0) {
        // property doesn't exist
        return '';
      }
      let mOffset = 2;
      dataProps.musicConfiguration = dataProps.musicConfiguration.replace(dataProps.musicConfiguration.slice(start + mOffset, end + 1), ';');
      forceUpdate();
      props.onChanged();
      props.triggerStateUpdate();
    }
  }, "Clear"), /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: e => {
      setCustomTime(true);
      forceUpdate();
      props.onChanged();
      props.triggerStateUpdate();
    }
  }, "Custom"))), customTime && /*#__PURE__*/React.createElement(Col, {
    style: {
      margin: "1rem 0rem"
    }
  }, /*#__PURE__*/React.createElement(Form.Control, {
    as: "textarea",
    value: getTimeSignature(dataProps.musicConfiguration),
    onChange: e => {
      dataProps.musicConfiguration = setMusicProperty(dataProps.musicConfiguration, 'M:', e.target.value);
      forceUpdate();
      props.onChanged();
      props.triggerStateUpdate();
    }
  }))), /*#__PURE__*/React.createElement(Col, {
    xs: 6
  }, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Base Note Length:"), " ", /*#__PURE__*/React.createElement("i", null, "The base note value for abc.")), /*#__PURE__*/React.createElement(Dropdown, {
    className: "mx-2"
  }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
    id: "dropdown-basic"
  }, getMusicPropertyValue(dataProps.musicConfiguration, 'L:')), /*#__PURE__*/React.createElement(Dropdown.Menu, null, /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: e => {
      dataProps.musicConfiguration = setMusicProperty(dataProps.musicConfiguration, 'L:', "1/1");
      forceUpdate();
      props.onChanged();
      props.triggerStateUpdate();
    }
  }, "1/1"), /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: e => {
      dataProps.musicConfiguration = setMusicProperty(dataProps.musicConfiguration, 'L:', "1/2");
      forceUpdate();
      props.onChanged();
      props.triggerStateUpdate();
    }
  }, "1/2"), /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: e => {
      dataProps.musicConfiguration = setMusicProperty(dataProps.musicConfiguration, 'L:', "1/4");
      forceUpdate();
      props.onChanged();
      props.triggerStateUpdate();
    }
  }, "1/4"), /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: e => {
      dataProps.musicConfiguration = setMusicProperty(dataProps.musicConfiguration, 'L:', "1/8");
      forceUpdate();
      props.onChanged();
      props.triggerStateUpdate();
    }
  }, "1/8"), /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: e => {
      dataProps.musicConfiguration = setMusicProperty(dataProps.musicConfiguration, 'L:', "1/16");
      forceUpdate();
      props.onChanged();
      props.triggerStateUpdate();
    }
  }, "1/16"), /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: e => {
      dataProps.musicConfiguration = setMusicProperty(dataProps.musicConfiguration, 'L:', "1/32");
      forceUpdate();
      props.onChanged();
      props.triggerStateUpdate();
    }
  }, "1/32"), /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: e => {
      dataProps.musicConfiguration = setMusicProperty(dataProps.musicConfiguration, 'L:', "1/64");
      forceUpdate();
      props.onChanged();
      props.triggerStateUpdate();
    }
  }, "1/64"))))))), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Measure Time:"), " ", /*#__PURE__*/React.createElement("i", null, "The time it takes to play a measure in miliseconds.")), /*#__PURE__*/React.createElement(NumericInput, {
    min: 0,
    value: parseInt(dataProps.musicDuration),
    onChange: e => {
      if (e) {
        dataProps.musicDuration = e.toString();
        props.triggerStateUpdate();
        props.onChanged();
      } else {
        dataProps.musicDuration = "0";
        props.triggerStateUpdate();
        props.onChanged();
      }
    }
  })), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Minimum Height:"), " ", /*#__PURE__*/React.createElement("i", null, "The minimum height of the sheet. Adjust to fit.")), /*#__PURE__*/React.createElement(NumericInput, {
    min: 0,
    value: parseInt(dataProps.minHeight) || 320,
    onChange: e => {
      if (e) {
        dataProps.minHeight = e.toString() + "px";
        props.triggerStateUpdate();
      } else {
        dataProps.minHeight = "0";
        props.triggerStateUpdate();
      }
    }
  })), /*#__PURE__*/React.createElement(Form.Group, {
    style: {
      paddingBottom: '1em'
    }
  }, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Range:"), " ", /*#__PURE__*/React.createElement("i", null, "The range (?)")), /*#__PURE__*/React.createElement("div", {
    style: {
      paddingBottom: '.5em'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      float: 'left'
    }
  }, "Lower:"), /*#__PURE__*/React.createElement("span", {
    style: {
      float: 'right'
    }
  }, /*#__PURE__*/React.createElement(NumericInput, {
    max: dataProps.rangeUpper,
    value: dataProps.rangeLower = dataProps.rangeLower ? dataProps.rangeLower : -3,
    onChange: e => {
      if (e > dataProps.rangeUpper) dataProps.rangeLower = dataProps.rangeUpper;else dataProps.rangeLower = e;
      props.triggerStateUpdate();
    }
  }))), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
    style: {
      paddingBottom: '.5em'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      float: 'left'
    }
  }, "Upper:"), /*#__PURE__*/React.createElement("span", {
    style: {
      float: 'right'
    }
  }, /*#__PURE__*/React.createElement(NumericInput, {
    min: dataProps.rangeLower,
    value: dataProps.rangeUpper = dataProps.rangeUpper ? dataProps.rangeUpper : 15,
    onChange: e => {
      if (e < dataProps.rangeLower) dataProps.rangeUpper = dataProps.rangeLower;else dataProps.rangeUpper = e;
      props.triggerStateUpdate();
    }
  }))), /*#__PURE__*/React.createElement(FormValidityReporter, {
    valid: dataProps.rangeLower <= dataProps.rangeUpper
  }, /*#__PURE__*/React.createElement("br", null), "Ensure the Lower bound is less than the Greater bound.")))), /*#__PURE__*/React.createElement(TabContextReporter, {
    index: "1",
    title: "2. Music Configuration"
  }, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Accordion, null, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Card.Header, null, /*#__PURE__*/React.createElement(Accordion.Toggle, {
    as: Button,
    variant: "link",
    eventKey: "0"
  }, "Full Configuration String")), /*#__PURE__*/React.createElement(Accordion.Collapse, {
    eventKey: "0"
  }, /*#__PURE__*/React.createElement(Card.Body, null, dataProps.musicConfiguration))))), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Music Config Properties: "), " ", /*#__PURE__*/React.createElement("i", null, "Special specification for formatting.")), properties.map((v, k) => {
    let isPrefix = v.indexOf(";") !== -1 ? true : false;
    if (v[0] === 'X') return;
    return /*#__PURE__*/React.createElement(Row, {
      style: {
        margin: "10px 2px"
      }
    }, /*#__PURE__*/React.createElement(Col, {
      fluid: "md",
      md: "auto"
    }, /*#__PURE__*/React.createElement("b", null, "Property: "), v.slice(0, v.indexOf(';'))), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(DestructiveButton, {
      size: "sm",
      variant: "danger",
      title: "Remove column",
      text: /*#__PURE__*/React.createElement("i", {
        className: "bi bi-trash"
      }),
      confirmation: /*#__PURE__*/React.createElement("i", {
        className: "bi bi-question-lg"
      }),
      className: "fs-sm",
      onClick: () => {
        let stringToRemove = '';
        if (isPrefix) {
          stringToRemove = dataProps.musicConfiguration.slice(getPosition(dataProps.musicConfiguration, "%%", k + 1), getPosition(dataProps.musicConfiguration, ";", k + 1) + 1);
        } else {
          stringToRemove = dataProps.musicConfiguration.slice(getPosition(dataProps.musicConfiguration, "%%", k + 1) - 1);
        }
        dataProps.musicConfiguration = dataProps.musicConfiguration.replace(stringToRemove, "");
        props.triggerStateUpdate();
        forceUpdate();
        props.onChanged();
      }
    })));
  }), /*#__PURE__*/React.createElement(Row, {
    style: {
      margin: "10px 2px"
    }
  }, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Add New Property: "))), /*#__PURE__*/React.createElement(Row, {
    style: {
      margin: "10px 2px"
    }
  }, /*#__PURE__*/React.createElement(Col, {
    fluid: "md",
    md: "auto"
  }, /*#__PURE__*/React.createElement(Form.Check, {
    type: "checkbox",
    label: "Is Prefix?",
    checked: isPrefix,
    inline: true,
    onChange: e => {
      setIsPrefix(e.target.checked);
      props.triggerStateUpdate();
      props.onChanged();
    }
  })), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Form.Control, {
    size: "sm",
    type: "text",
    value: newProperty,
    onChange: e => {
      setNewProperty(e.target.value);
      forceUpdate();
      props.onChanged();
    }
  })), /*#__PURE__*/React.createElement(Col, {
    xs: 2
  }, /*#__PURE__*/React.createElement(Button, {
    block: true,
    size: "sm",
    variant: "success",
    onClick: () => {
      if (newProperty === '') {
        return;
      }
      if (isPrefix) {
        dataProps.musicConfiguration = "%%" + newProperty + ";" + dataProps.musicConfiguration;
      } else {
        dataProps.musicConfiguration = dataProps.musicConfiguration + ";" + "%%" + newProperty + " ";
      }
      setIsPrefix(false);
      setNewProperty('');
      props.triggerStateUpdate();
      props.onChanged();
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "bi bi-plus-lg"
  }))))), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Initial Score:"), " ", /*#__PURE__*/React.createElement("i", null, "The initial notes to be displayed (abc notation)")), /*#__PURE__*/React.createElement(Form.Control, {
    as: "textarea",
    value: dataProps.musicInitial,
    onChange: e => {
      dataProps.musicInitial = e.target.value;
      forceUpdate();
      props.onChanged();
    }
  })), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Music Annotation:")), /*#__PURE__*/React.createElement(Form.Control, {
    as: "textarea",
    value: dataProps.musicAnnotation,
    onChange: e => {
      dataProps.musicAnnotation = e.target.value;
      forceUpdate();
      props.triggerStateUpdate();
      props.onChanged();
    }
  })))), /*#__PURE__*/React.createElement(TabContextReporter, {
    index: "2",
    title: "3. Response Details"
  }, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Answer(s):"), " ", /*#__PURE__*/React.createElement("i", null, "(abc notation)")), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Form.Label, null, "Answer:")), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Form.Label, null, "Feedback:")), /*#__PURE__*/React.createElement(Col, {
    xs: 1,
    style: {
      marginRight: "1rem"
    }
  }, /*#__PURE__*/React.createElement(Form.Label, null, "Correct:")), /*#__PURE__*/React.createElement(Col, {
    xs: 1,
    style: {
      marginRight: "1rem"
    }
  })), dataProps.answers.map((v, k) => {
    return /*#__PURE__*/React.createElement(Row, {
      style: {
        marginBottom: ".5rem"
      }
    }, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Form.Control, {
      key: k + "1",
      as: "textarea",
      value: v.answer,
      onChange: e => {
        dataProps.answers[k].answer = e.target.value;
        forceUpdate();
        props.onChanged();
      }
    })), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Form.Control, {
      key: k + "2",
      as: "textarea",
      value: v.feedback,
      onChange: e => {
        dataProps.answers[k].feedback = e.target.value;
        forceUpdate();
        props.onChanged();
      }
    })), /*#__PURE__*/React.createElement(Col, {
      xs: 1
    }, /*#__PURE__*/React.createElement(Form.Check, {
      key: k,
      type: "checkbox",
      checked: v.correct,
      onChange: e => {
        dataProps.answers[k].correct = e.target.checked;
        forceUpdate();
        props.onChanged();
        //props.triggerStateUpdate()
      }
    })), /*#__PURE__*/React.createElement(Col, {
      xs: 1,
      style: {
        marginRight: ".5rem"
      }
    }, /*#__PURE__*/React.createElement(DestructiveButton, {
      size: "sm",
      variant: "danger",
      title: "Remove answer",
      text: /*#__PURE__*/React.createElement("i", {
        className: "bi bi-trash"
      }),
      confirmation: /*#__PURE__*/React.createElement("i", {
        className: "bi bi-question-lg"
      }),
      className: "fs-sm",
      onClick: () => {
        dataProps.answers.splice(k, 1);
        forceUpdate();
        props.onChanged();
        //props.triggerStateUpdate()
      }
    })));
  }), /*#__PURE__*/React.createElement(Button, {
    title: "Add an answer",
    variant: "success",
    style: {
      margin: '.5rem .25rem'
    },
    onClick: () => {
      dataProps.answers.push({
        answer: "[]",
        feedback: "placeholder",
        correct: true
      });
      forceUpdate();
      props.onChanged();
      //props.triggerStateUpdate()
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "bi bi-plus-lg"
  }))))), /*#__PURE__*/React.createElement(TabContextReporter, {
    index: "3",
    title: "4. Feedback"
  }, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Correct Answer Feedback:")), /*#__PURE__*/React.createElement(Form.Control, {
    as: "textarea",
    value: dataProps.feedbackCorrect,
    onChange: e => {
      dataProps.feedbackCorrect = e.target.value;
      forceUpdate();
      props.onChanged();
    }
  })), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Incorrect Answer Feedback:")), /*#__PURE__*/React.createElement(Form.Control, {
    as: "textarea",
    value: dataProps.feedbackIncorrect,
    onChange: e => {
      dataProps.feedbackIncorrect = e.target.value;
      forceUpdate();
      props.onChanged();
    }
  })), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: "auto"
  }, /*#__PURE__*/React.createElement(Form.Check, {
    type: "checkbox",
    checked: dataProps.musicButtonSharp,
    onChange: e => {
      dataProps.musicButtonSharp = e.target.checked;
      props.triggerStateUpdate();
      props.onChanged();
    }
  })), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Sharp Button")))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: "auto"
  }, /*#__PURE__*/React.createElement(Form.Check, {
    type: "checkbox",
    checked: dataProps.musicButtonFlat,
    onChange: e => {
      dataProps.musicButtonFlat = e.target.checked;
      props.triggerStateUpdate();
      props.onChanged();
    }
  })), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Flat Button")))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: "auto"
  }, /*#__PURE__*/React.createElement(Form.Check, {
    type: "checkbox",
    checked: dataProps.musicButtonNatural,
    onChange: e => {
      dataProps.musicButtonNatural = e.target.checked;
      props.triggerStateUpdate();
      props.onChanged();
    }
  })), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Natural Button")))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: "auto"
  }, /*#__PURE__*/React.createElement(Form.Check, {
    type: "checkbox",
    checked: dataProps.musicButtonDoubleFlat,
    onChange: e => {
      dataProps.musicButtonDoubleFlat = e.target.checked;
      props.triggerStateUpdate();
      props.onChanged();
    }
  })), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Double Flat Button:"), " ", /*#__PURE__*/React.createElement("i", null, "If checked, the double flat button will be displayed."))))), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: "auto"
  }, /*#__PURE__*/React.createElement(Form.Check, {
    type: "checkbox",
    checked: dataProps.musicButtonDoubleSharp,
    onChange: e => {
      dataProps.musicButtonDoubleSharp = e.target.checked;
      props.triggerStateUpdate();
      props.onChanged();
    }
  })), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Double Sharp Button:"), " ", /*#__PURE__*/React.createElement("i", null, "If checked, the double sharp button will be displayed.")))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: "auto"
  }, /*#__PURE__*/React.createElement(Form.Check, {
    type: "checkbox",
    checked: dataProps.musicButtonAudio,
    onChange: e => {
      dataProps.musicButtonAudio = e.target.checked;
      props.triggerStateUpdate();
      props.onChanged();
    }
  })), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Music Button Audio:"), " ", /*#__PURE__*/React.createElement("i", null, "Displays play button to user."))))))));
}